import React from 'react';

export default function Mission() {
  return (
    <section className="mission">
      <div className="mission-inner">
        <p className="mission-text">
          AI workflow automation, elite rapid engineering teams, applied research,
          and the integration of large-scale intelligent systems are central to
          how we help organizations move faster. Vector Labs combines
          cutting-edge research with real-world product engineering to deliver
          systems that work.
        </p>
      </div>
    </section>
  );
}
